import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { withConfig } from 'src/utils/withConfig';

const InvalidInputValue = (isInvalidValue: boolean): string => {
    if (isInvalidValue === false) {
        return '';
    } else {
        return `
            ::before {
                content: '!';
                display: inline-block;
                position: absolute;
                width: 14px;
                height: 14px;
                line-height: 1;
                font-size: 14px;
                border-radius: 50%;
                text-align: center;
                background: #e45e59;
                top: 2.0625rem;
                right: 0.875rem;
                color: ${mainColors.default.light};
                z-index: 2;
            }
        `;
    }
};

export const LoginFormWrapper = styled('div', { label: 'LoginFormWrapper' })`
    margin-top: 43px;
`;

export const LoginFormInputWrapper = styled('div', { label: 'LoginFormInputWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    position: relative;
`;

export const LoginFormInputLabel = styled('label', { label: 'LoginFormInputLabel' })<{isInvalidValue: boolean}>`
    position: static;
    white-space: normal;
    color: ${mainColors.default.dark};
    font-weight: 500;
    font-size: 12px;
    line-height: 1.33;
    margin-bottom: 4px;
    letter-spacing: 1px;
    ${({ isInvalidValue }): string => InvalidInputValue(isInvalidValue)};
`;

interface LoginFormInputPropsType {
    isInvalid: boolean;
}

export const LoginFormInput = withConfig(theme => styled('input', { label: 'LoginFormInput' }) <LoginFormInputPropsType>`
    height: 40px;
    border: none;
    margin-bottom: 24px;
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-weight: 400;
    padding-left: 10px;
    outline: ${({ isInvalid }): string => isInvalid ? `${mainColors.status.error}` : 'none'};
    background-color: ${theme.input.bgColor};
    color: ${mainColors.default.dark};
`);

export const LoginFormError = styled('div', { label: 'LoginFormError' })`
    background: ${mainColors.status.error};
    color: ${mainColors.default.light};
    padding: 5px;
    margin-bottom: 24px;
    text-align: center;
    border-radius: 3px;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.42;
`;

export const LoginButton = withConfig(theme => styled('button', { label: 'LoginButton' })`
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    width: 100%;
    padding: 0;
    border: none;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    padding: 12px;
    cursor: pointer;
    color: ${theme.buttons.txtColor};
    background: ${theme.buttons.bgColor};
`);
